import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCardIconButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsDateRangeModule } from '../../common/component/date-range';
import { CmpsDateTimePickerModule } from '../../common/component/datetime-picker';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { epicObs } from '../../store';
import { CmpsTeamsCallAuthModule } from '../auth';

import { TranscriptImportDialogComponent } from './transcript-import-dialog.component';
import { transcriptImportDialogEpics } from './transcript-import-dialog.epic';
import { TranslationIdMap as DialogTranslationIdMap } from './transcript-import-dialog.i18n';
import { TranscriptImportDialogService } from './transcript-import-dialog.service';

@NgModule({
    declarations: [TranscriptImportDialogComponent],
    providers: [TranscriptImportDialogService],
    imports: [
        CmpsButtonModule,
        CmpsCardIconButtonModule,
        CmpsCommonModule,
        CmpsDateRangeModule,
        CmpsDateTimePickerModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(DialogTranslationIdMap),
        CmpsTeamsCallAuthModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsTeamsCallTranscriptImportDialogModule {
    constructor() {
        transcriptImportDialogEpics.forEach((e) => epicObs.next(e));
    }
}
